import { FormControl } from '@angular/forms';

export interface IAnnex {
  Title: string;
  Id?: string;
  File: Blob | string | null;
  isLoader: boolean;
  visible: boolean;
  AllowDownload: boolean;
  DisableUpload: boolean;
}

export enum AnnexEnum {
  NotaFiscal = 'Nota Fiscal',
  MemoriaCalculo = 'Memória de Cálculo',
  AutorizacaoRepasse = 'Autorização Repasse',
  Rpa = "RPA"
}

export interface IInvoiceInfoForm {
  InvoiceDate: FormControl<string>;
  InvoiceNumber: FormControl<string>;
  BatchId: FormControl<string>;
}

export interface IInvoiceInfo {
  InvoiceDate: string;
  InvoiceNumber: string;
  BatchId: string;
}

export interface IRpaInfoForm {
  RpaDate: FormControl<string>;
  RpaNumber: FormControl<string>;
  BatchId: FormControl<string>;
}

export interface IRpaInfo {
  RpaDate: string;
  RpaNumber: string;
  BatchId: string;
}